<template>
    <div class="full-cad-container">
        <div class="display-cad-offers-container">
            <div class="cad-offer-container">
                <div class="cad-row no-hover">
                    <div class="cad-header" v-for="elem in offers"><span>{{elem.header}}</span></div>
<!--                    <div class="cad-header"><span>Nr. art.</span></div>-->
<!--                    <div class="cad-header"><span>Cad</span></div>-->
<!--                    <div class="cad-header"><span>Typ</span></div>-->
<!--                    <div class="cad-header"><span>Nr. typu</span></div>-->
<!--                    <div class="cad-header"><span>Pozycja</span></div>-->
<!--                    <div class="cad-header"><span>Przejscie na ssaniu</span></div>-->
<!--                    <div class="cad-header"><span>Polaczenie</span></div>-->
<!--                    <div class="cad-header"><span>Przejście na tłoczeniu</span></div>-->
<!--                    <div class="cad-header"><span>Przejście na tłoczeniu</span></div>-->
                </div>
                <div class="cad-row">
                    <div v-for="elem in offers">
                        <a href="#" v-if="elem.value == 'Pobierz'"><span class="cad-content">{{elem.value}}</span></a>
                        <span class="cad-content" v-else>{{elem.value}}</span>
                    </div>
                </div>
            </div>
            <div v-if="offers.length == 0" class="cad-no-result">
                <span>Brak wyników</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CadTable",
        data() {
            return {
                offers: [
                    {
                        title: 'number_article',
                        header: 'Nr. art.',
                        value: '1519 006'
                    },
                    {
                        title: 'download',
                        header: 'Cad',
                        value: 'Pobierz'
                    },
                    {
                        title: 'fan_type',
                        header: 'Typ',
                        value: 'US-FHN'
                    },
                    {
                        title: 'fan_type_number',
                        header: 'Nr typu',
                        value: '151 500 15'
                    },
                    {
                        title: 'position',
                        header: 'Pozycja',
                        value: 'GL360'
                    },
                    {
                        title: 'choke_transition',
                        header: 'Przejscie na ssaniu',
                        value: 500
                    },
                    {
                        title: 'connecting',
                        header: 'Połączenie',
                        value: 'SK'
                    },
                    {
                        title: 'transition_on_pressing',
                        header: 'Przejście na tłoczeniu',
                        value: 560
                    },
                    {
                        title: 'transition_on_pressing2',
                        header: 'Przejście na tłoczeniu',
                        value: 760
                    },
                ]

            }
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },
        },

        computed: {
            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },
        }
    }
</script>